module.exports = __webpack_public_path__ + "static/media/emptystate.f4761a80.svg";